// import { startCase, camelCase } from "lodash";

export default class Directions {
  private toQueryString(query: Record<string, string>): string {
    return Object.keys(query)
      .map(k => k + "=" + query[k])
      .join("&");
  }

  private toGoogleMapsURL(
    startCoords: number[] | null,
    endCoords: number[]
  ): string {
    const googleDirUrl = "https://www.google.com/maps/dir/?api=1";
    const query: Record<string, string> = {
      destination: endCoords.join(",")
    };
    if (startCoords) query.origin = startCoords?.join(",");
    return `${googleDirUrl}&${this.toQueryString(query)}`;
  }

  private toAppleMapsURL(
    startCoords: number[] | null,
    endCoords: number[]
  ): string {
    const appleDirUrl = "https://maps.apple.com/";
    const query: Record<string, string> = {
      daddr: endCoords.join(",")
    };
    if (startCoords) query.saddr = startCoords?.join(",");
    return `${appleDirUrl}?${this.toQueryString(query)}`;
  }

  private isMacDevice(): boolean {
    return [
      "Macintosh",
      "MacIntel",
      "MacPPC",
      "Mac68K",
      "iPhone",
      "iPad",
      "iPod"
    ].includes(window.navigator.platform);
  }

  public getDirectionsUrl(
    startCoords: number[] | null,
    endCoords: number[]
  ): string {
    return this.isMacDevice()
      ? this.toAppleMapsURL(startCoords, endCoords)
      : this.toGoogleMapsURL(startCoords, endCoords);
  }
}
